import { Badge, Button } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { FilterAltIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';

const FilterButton = ({
  onClick,
  initInspectionFilterValues,
  inspectionsFilter,
  size = 'medium',
}) => {
  const activeCount = Object.keys(inspectionsFilter).filter(
    (key) => inspectionsFilter[key] !== initInspectionFilterValues[key]
  ).length;

  return (
    <Badge badgeContent={activeCount} color="primary" overlap="rectangular">
      <Button
        size={size}
        onClick={onClick}
        endIcon={<FilterAltIcon />}
        variant="outlined"
        color="secondary"
      >
        <ButtonSpan>
          <FormattedMessage id="button.filter" />
        </ButtonSpan>
      </Button>
    </Badge>
  );
};

export default FilterButton;
